export default function createTimeout(fn, delay = 0) {
  const id = setTimeout(fn, delay);
  return () => clearTimeout(id);
}
